import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import googlePlayBtn from "../../images/google_play_btn_image.png";
import mainImage from "../../images/phone_screen_1.png"
import courses from "../../images/phone_screen_3.png";
import cards from "../../images/phone_screen_2.png";
import tutor from '../../images/phone_screen_4.png'
import mate from '../../images/phone_screen_5.png'
import bannerLogo from "../../images/logo_with_jp.png";
import googlePlayLightBtn from "../../images/google_play_tbn_light.png";
import Footer from "../../components/Footer";
import {trackClick} from "../../api/analytic";

const faqData = [
    {
        question: "Is it suitable for absolute beginners?",
        answer: "Absolutely! While our ultimate goal is to get you speaking comfortably through engaging daily interactions with our companions, we have dedicated sections and flashcards specifically designed for absolute beginners. Our AI tutor will happily guide you through the very basics to get you started!"
    },
    {
        question: "Is knowledge of hiragana/katakana required?",
        answer: "Not at all! We provide introductory lessons, and our tutor is more than happy to help you start from scratch—so don't hesitate to jump right in. While having a basic level helps you unlock the maximum fun of chatting with your companions, you can definitely begin your journey from absolute zero."
    },
    {
        question: "How is AI Cards different from Duolingo or Anki?",
        answer: (
            <>
                <p>
                    AI Cards goes beyond standard learning apps by offering a unique virtual companion experience. It’s not just a simulation of talking to a real person; it includes engaging mechanics like building a relationship with your companion, exploring contextual dialogues, and much more.
                </p>
                <p>
                    Additionally, we combine three simple yet powerful learning mechanics into one seamless loop:
                </p>
                <ul className="faq-list">
                    <li>
                        <strong>Spaced Repetition Flashcards:</strong> To rapidly expand your vocabulary (similar to Anki).
                    </li>
                    <li>
                        <strong>Interactive Courses:</strong> To improve your overall language comprehension and grammar.
                    </li>
                    <li>
                        <strong>Real-time Conversation Practice:</strong> To solidify everything you've learned by actually chatting with your AI companions.
                    </li>
                </ul>
            </>
        )
    }
];

const Home = () => {
    const navigate = useNavigate();
    const [openFaqs, setOpenFaqs] = useState({ 0: true, 1: true, 2: true });

    const toggleFaq = (index) => {
        setOpenFaqs(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const goToTerms = () => {
        trackClick("terms")
        navigate('/terms');
    };

    return (
        <div className="App">
            {/* Navigation */}
            <nav className="navbar top-nav">
                <div className="nav-container">
                    <div className="nav-logo">
                        <img src={bannerLogo} alt="AI Cards: Learn & Speak Japanese Logo" className="logo-image-top" />
                    </div>
                </div>
            </nav>

            {/* Hero Section */}
            <section className="hero-section">
                <div className="container">
                    <div className="hero-layout">
                        <div className="hero-text-content">
                            <h2>Stop learning Japanese</h2>
                            <h1>Start speaking it</h1>
                            <p>
                                Forget boring flashcards. AI Cards creates a personalized environment where you learn through real-time conversation and immersive practice.</p>
                            <div className="store-buttons">
                                <a href="https://play.google.com/store/apps/details?id=com.cardapp.learn.ai"
                                   onClick={() => trackClick("googlePlay")}
                                >
                                    <img src={googlePlayBtn} alt="Get AI Cards on Google Play Store" className="store-badge" />
                                </a>
                            </div>
                        </div>

                        <div className="hero-visuals">
                            <div className="phone-graphic-container top-phone">
                                <img src={mainImage} alt="AI Cards Japanese Learning Mobile App Interface" className="floating-phone phone-1" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 1 Discover Section */}
            <section className="discover-section">
                <div className="container">
                    <div className="discover-layout">
                        <div className="discover-visuals">
                            <img src={cards} alt="Japanese Smart Flashcards and Spaced Repetition Interface" className="floating-phone phone-2" />
                        </div>
                        <div className="discover-text-content">
                            <h2>Never forget a word again.</h2>
                            <p>Learn new words with smart flashcards and spaced repetition.
                                Tap a word to hear pronunciation or ask AI for examples and explanations.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* 2 Manage Section */}
            <section className="manage-section">
                <div className="container">
                    <div className="manage-layout">
                        <div className="manage-text-content">
                            <h2>Understand how Japanese works</h2>
                            <p>Interactive courses explain grammar and sentence structure step by step.
                                No confusion. Just clear progress.</p>
                        </div>
                        <div className="manage-visuals">
                            <img src={courses} alt="Interactive Japanese Grammar Courses Interface" className="floating-phone phone-3" />
                        </div>
                    </div>
                </div>
            </section>


            {/* 3 Discover Section */}
            <section className="discover-section">
                <div className="container">
                    <div className="discover-layout">
                        <div className="discover-visuals">
                            <img src={tutor} alt="AI Japanese Language Tutor Practice Screen" className="floating-phone phone-2" />
                        </div>
                        <div className="discover-text-content">
                            <h2>Practice with your AI tutor</h2>
                            <p>Ask questions, get corrections, and practice conversations anytime.</p>
                        </div>
                    </div>
                </div>
            </section>


            {/* 4 Manage Section */}
            <section className="manage-section">
                <div className="container">
                    <div className="manage-layout">
                        <div className="manage-text-content">
                            <h2>Chat with your Japanese companion</h2>
                            <p>Your companion speaks only Japanese — just like a real person.
                                The best way to learn is to use the language.</p>
                        </div>
                        <div className="manage-visuals">
                            <img src={mate} alt="AI Japanese Companion Interactive Chat Screen" className="floating-phone phone-3" />
                        </div>
                    </div>
                </div>
            </section>

            {/* FAQ Section */}
            <section className="faq-section">
                <div className="container">
                    <div className="faq-header">
                        <h2>❓ Frequently Asked Questions</h2>
                    </div>
                    <div className="faq-grid">
                        {faqData.map((item, index) => {
                            const isOpen = !!openFaqs[index];
                            return (
                                <div key={index} className={`faq-item ${isOpen ? 'open' : ''}`}>
                                    <button 
                                        className="faq-question" 
                                        onClick={() => toggleFaq(index)}
                                        aria-expanded={isOpen}
                                    >
                                        <span>{item.question}</span>
                                        <span className="faq-toggle-icon">{isOpen ? '▲' : '▼'}</span>
                                    </button>
                                    {isOpen && (
                                        <div className="faq-answer">
                                            {typeof item.answer === 'string' ? <p>{item.answer}</p> : item.answer}
                                        </div>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <div className="container">
                    <div className="cta-layout">
                        <h2>Start speaking Japanese today</h2>
                        <p>Practice vocabulary, grammar and real conversations in one learning loop.</p>
                        <div className="cta-buttons">
                            <button onClick={goToTerms} className="terms-button">
                                <span className="terms-icon">📄</span>
                                <div className="terms-text">
                                    <span className="terms-small">Read our</span>
                                    <span className="terms-large">Terms of Use</span>
                                </div>
                            </button>
                            <button className="terms-button"
                                    onClick={() => trackClick("googlePlay")}
                            >
                                <a href="https://play.google.com/store/apps/details?id=com.cardapp.learn.ai">
                                    <img src={googlePlayLightBtn} alt="Get AI Cards on Google Play Store" className="store-badge-light" />
                                </a>
                            </button>
                        </div>
                    </div>
                </div>
            </section>

           <Footer />
        </div>
    );
}

export default Home;

